<template>
  <div>
    <header
      :class="$style.subHeader"
      data-test-id="attributeMappingHeader"
    >
      Attribute Mapping
    </header>

    <p data-test-id="descriptionSpan">
      The following table lists attributes that JumpCloud sends to your custom SCIM integration.
    </p>
    <GenericScimAttributesListEditor
      :handleChangeListItem="handleChangeListItem"
      :handleRemoveListItem="handleRemoveListItem"
      :listItems="translationRules"
    />
    <a
      v-if="showAddAttributeButton"
      :class="$style.addAttributeAnchor"
      data-test-id="addAttributeAnchor"
      @click="addAttribute"
    >
      + Add attribute
    </a>
  </div>
</template>

<script>
import GenericScimAttributesListEditor from 'client/applications/scim/GenericScimAttributesListEditor.vue';
import IdentityManagementMixin from 'client/applications/mixins/IdentityManagementMixin';

export default {
  name: 'ScimConnectorAttributes',

  components: {
    GenericScimAttributesListEditor,
  },

  mixins: [
    IdentityManagementMixin,
  ],

  props: {
    showAddAttributeButton: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    addAttribute() {
      this.addTranslationRule();
    },

    handleChangeListItem(index, dataSentBack) {
      const { _id } = this.translationRules[index];
      this.updateTranslationRule({ _id, ...dataSentBack });
    },

    handleRemoveListItem(_index, object) {
      const { _id } = object;
      this.removeTranslationRule(_id);
    },
  },
};

</script>

<style module>
@import 'css/IdentityManagementCommon.css';

.addAttributeAnchor {
  font-weight: 600;
  margin-bottom: 20px;
  text-align: start;
}

.addAttributeAnchor:hover {
  cursor: pointer;
  text-decoration: none !important;
}
</style>
